import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Channel } from 'icreate/common/models/channel';
import { NonDigitalDataType, NonDigitalValueFlag, ReposeGroup } from 'icreate/common/models/repose-group';
import { ReposeDialogComponent, ReposeGroupStep } from '../repose-dialog/repose-dialog.component';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { defaultAlarmDropDownItem } from '@models/repose-group';

@Component({
    selector: 'app-repose-detail-dialog',
    templateUrl: './repose-detail-dialog.component.html',
    styleUrls: ['./repose-detail-dialog.component.css'],
    standalone: false,
})
export class ReposeDetailDialogComponent {
    readonly STEP1 = ReposeGroupStep.STEP1;
    readonly STEP2 = ReposeGroupStep.STEP2;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            reposeGroup: ReposeGroup;
            channel: Channel;
            reposeGroupList: ReposeGroup[];
        },
        private dialogRef: MatDialogRef<ReposeDetailDialogComponent>,
        private dialog: MatDialog,
        private translate: TranslateService
    ) {}

    close() {
        this.dialogRef.close();
    }

    getReposeName() {
        return this.data?.reposeGroup.name || '';
    }

    getChannelName() {
        return this.data?.channel.opsData.name || '';
    }

    getReposeChannelType() {
        return this.data?.channel.opsData.channelType || '';
    }

    getTriggerCondition() {
        if (this.data.reposeGroup.nonDigitalDataType === NonDigitalDataType.VALUE) {
            let message;
            if (this.data.reposeGroup.nonDigitalValueFlag === NonDigitalValueFlag.EXCEED) {
                message = this.translate.instant('repose-group.dialog.digital.set-point.exceeds');
            } else {
                message = this.translate.instant('repose-group.dialog.digital.set-point.below');
            }
            return message;
        } else if (this.data.reposeGroup.nonDigitalDataType === NonDigitalDataType.STATUS) {
            const findItem = defaultAlarmDropDownItem.find(
                item => item.propertyName === this.data.reposeGroup.nonDigitalAlarm
            );

            let itemName = this.translate.instant(findItem.name);
            let message = this.translate.instant('repose-group.dialog.digital.set-point.reaches');

            return message + ' ' + itemName;
        } else if (this.data.reposeGroup.digitalChannelStatus == 0 || this.data.reposeGroup.digitalChannelStatus == 1) {
            let message = this.translate.instant('repose-group.dialog.digital.set-point.message');

            return message + ' ';
        }
    }

    getValue() {
        if (this.data.reposeGroup.nonDigitalDataType === NonDigitalDataType.VALUE) {
            return this.data.reposeGroup.setPoint + ' ' + this.data.channel?.opsData.measurementUnit;
        } else if (this.data.reposeGroup.nonDigitalDataType === NonDigitalDataType.STATUS) {
            let setPoint = this.data.channel?.fcuData[this.data.reposeGroup.nonDigitalAlarm]?.setPoint;
            return setPoint ? setPoint + ' ' + this.data.channel?.opsData.measurementUnit : '';
        } else if (this.data.reposeGroup.digitalChannelStatus == 0) {
            return this.data.channel?.fcuData.digitalAlarmSetting.statusStringContactOff;
        } else if (this.data.reposeGroup.digitalChannelStatus == 1) {
            return this.data.channel?.fcuData.digitalAlarmSetting.statusStringContactOn;
        }
    }

    async openEditReposeGroupDialog(reposeGroupStep: ReposeGroupStep) {
        try {
            const dialogRef = this.dialog.open(ReposeDialogComponent, {
                data: {
                    ...this.data.reposeGroup,
                    currentStep: reposeGroupStep,
                    reposeGroupList: this.data.reposeGroupList,
                },
            });

            const result = await firstValueFrom(dialogRef.afterClosed());

            if (result) {
                Object.assign(this.data.reposeGroup, result.reposeGroup);
                this.data.channel = result.channel;
                if (result.close) {
                    this.editReposeGroup();
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    async editReposeGroup() {
        try {
            this.dialogRef.close({
                reposeGroup: this.data.reposeGroup,
                channel: this.data.channel,
            });
        } catch (error) {
            console.log(error);
        }
    }
}
